import * as tslib_1 from "tslib";
import { updateUserConfiguration } from 'owa-options-core';
import store from '../store/store';
import { getUserConfiguration } from 'owa-session-store';
import { action, select } from 'satcheljs/lib/legacy';
import { raiseAction } from 'satcheljs/lib/legacy/stitch';
import setIsFocusedInboxCapableService from '../services/setIsFocusedCapableService';
import { logUsage } from 'owa-analytics';
var saveFocusInboxOptionStitchName = 'saveFocusInboxOptionStitchName';
var saveFocusedInboxOption = select({
    optionState: function () { return store; },
    userOptions: function () { return getUserConfiguration().UserOptions; },
})(action('saveFocusedInboxOption')(function saveFocusedInboxOption(isEnabledOverride, state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var optionState, userOptions, servicePromises;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    optionState = state.optionState, userOptions = state.userOptions;
                    if (isEnabledOverride !== undefined) {
                        optionState.isEnabled = isEnabledOverride;
                    }
                    userOptions.IsFocusedInboxEnabled = optionState.isEnabled;
                    // Raise stitch so that, if we're running in mail, the focused inbox will toggle on and off
                    raiseAction(saveFocusInboxOptionStitchName)(userOptions.IsFocusedInboxEnabled);
                    servicePromises = [];
                    servicePromises.push(updateUserConfiguration([
                        {
                            propertyName: 'IsFocusedInboxEnabled',
                            propertyType: 'Boolean',
                            propertyValue: "" + optionState.isEnabled,
                        },
                    ]));
                    // Make a request to set IsFocusedInboxCapable if IsFocusedInboxEnabled is set to true
                    if (userOptions.IsFocusedInboxEnabled) {
                        servicePromises.push(setIsFocusedInboxCapableService());
                    }
                    return [4 /*yield*/, Promise.all(servicePromises)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
export default saveFocusedInboxOption;
var OPTION_QUICK_SETTING_USAGE_KEY = 'QuickSettingFocusedInbox';
export function saveFocusedInboxQuickOption(isEnabled) {
    logUsage(OPTION_QUICK_SETTING_USAGE_KEY, ["" + isEnabled]);
    saveFocusedInboxOption(isEnabled);
}
//# sourceMappingURL=saveFocusedInboxOption.js.map